<template>
  <div class="overview-container">
    <detailoverviewinfo-nav class="overview-content-left" :onchaindata="onchaindata" :offchaindata="offchaindata" />
    <detailmap-nav class="overview-content-right"  mapWidth="440px" mapHeight="440px"></detailmap-nav>
  </div>
</template>

<script>
import DetailoverviewinfoNav from "./Detailoverviewinfo";
import DetailmapNav from "./Detailmap";
export default {
  name: "detailoverview",
  components: {
    DetailoverviewinfoNav,
    DetailmapNav
  },
  props: {
    onchaindata: {
      type: Object,
      default:function(){
        return {}
      }
    },
    offchaindata: {
      type: Object,
      default:function(){
        return {}
      }
    },
  },

};
</script>
<style scoped lang="scss">
.overview-container{
  max-width: 1200px;
  background-color: #fff;
  margin: auto;
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  box-sizing: border-box;

  @include mobile {
    padding: 0;
    max-width: 100%;
    flex-direction: column-reverse;
  }
}
.overview-content-left{
  width:50%;
  padding-top: 10px;
  padding-bottom: 32px;
  text-align: left;

  @include mobile {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
.overview-content-right{
  display: flex;
  justify-content: center;
  align-items: center;

  @include mobile {
    width: 100% !important;
  }
}
</style>

